"use strict";

var match = require("./match.js");

var stop = require("./stop.js");

module.exports = stopIf;

function stopIf(f, stopVal) {
  return match.case(f)(arguments.length == 2 ? _ => stop(stopVal) : stop).else(a => a);
}